export const POLLING_MAX_RETRIES = 15;
export const POLLING_INTERVAL = 1000;
